import React from 'react'
import useAssistant from '../../common/hooks/useAssistant'

export default function ResendLastMessageLink({ href, children }: { href: string; children: React.ReactNode }) {
  const assistant = useAssistant()

  const handleResendClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    event.stopPropagation()

    const lastUserMessage = assistant.messages
      .slice()
      .reverse()
      .find(message => message.author !== '@skipper' && !message.error)

    if (lastUserMessage) {
      assistant.send(lastUserMessage.text).catch(error => {
        // eslint-disable-next-line no-console
        console.error('Failed to resend message:', error)
      })
    }
  }

  return (
    <a href={href} onClick={handleResendClick}>
      {children}
    </a>
  )
}
